import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { logWarn } from "../lib/logger";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth, skip /me. AuthCallback handles it.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (error) {
      logWarn("Logout failed:", error);
    }
    setUser(null);
  }, []);

  const deleteAccount = useCallback(async () => {
    await api.delete("/auth/me");
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ user, setUser, loading, logout, deleteAccount, refresh: checkAuth }),
    [user, loading, logout, deleteAccount, checkAuth]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
